import { useEffect, useState } from 'react';
import useSavedEvents from '@hooks/favorites/useSavedEvents';

const useSavedEventFilters = additionalFilters => {
    const { data: savedEvents } = useSavedEvents();
    const [filters, setFilters] = useState('');

    useEffect(() => {
        if (!savedEvents) {
            return;
        }

        let filterString =
            savedEvents.length === 0
                ? 'objectID:NOT-AN-EVENT'
                : `(${savedEvents.map(event => `objectID:event-${event.recordId}`).join(' OR ')})`;

        if (additionalFilters) {
            filterString += ` AND ${additionalFilters}`;
        }

        setFilters(filterString);
    }, [additionalFilters, savedEvents]);

    return { filters };
};

export default useSavedEventFilters;
